import React from 'react';

interface ServiceStatusCardProps {
    carPlate: string;
}

const WaitingForPickupStatusCard: React.FC<ServiceStatusCardProps> = ({ carPlate }) => {
    return (
        <div className="row d-flex flex-column-reverse flex-md-row">
            <div className="col-md-6 my-md-5">
                <h1>Listo para recoger</h1>
                <h2>Placa: {carPlate}</h2>
                <p>Tu vehículo está esperando por ti en el punto de entrega. Por favor preséntate para recogerlo.</p>
                <div className="alert alert-success">
                    <strong>¡Tu vehículo te está esperando!</strong>
                </div>
            </div>
            <div className="col-md-6 my-5 p-1 d-flex justify-content-center align-items-center" style={{ backgroundColor: "#ffffff44", borderRadius: '8px' }}>
                <img src="/assets/waiting_pickup.svg" alt="Vehículo esperando" />
            </div>
        </div>
    );
};

export default WaitingForPickupStatusCard;
